var map = {
	"./1001.svg": 5068,
	"./1002.svg": 2661,
	"./1003.svg": 6758,
	"./1004.svg": 3482,
	"./1005.svg": 129,
	"./1006.svg": 3553,
	"./1008.svg": 502,
	"./1014.svg": 7957,
	"./5001.svg": 2051,
	"./5002.svg": 7545,
	"./5003.svg": 8910,
	"./5004.svg": 2038,
	"./5005.svg": 8352,
	"./5006.svg": 6270,
	"./5007.svg": 169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2447;